/**
 * @title rxdrugdetails.js: Sub-module for Rx pages
 * @description This module is used to handle various drug search tasks
 */
define([], function() {	
	
	var rxDrugDetails = {
			
		init : function(options) {
			this.bindEvents();
		},
		/**
		 * bind events
		 *  
		 */
		bindEvents: function() {
			if ($('#navigation-tabs .active').find('a').attr("href")) {
				if('drug-detail-info' != $('#navigation-tabs .active').find('a').attr("href").substr(1)){
					$('#print-link').addClass('hidden');
				}
			} else {
				console.warn('Navigation tabs empty.');
			}
			
			$('#navigation-tabs a').click(function() {
				$('a[href*=drug-detail-price]').removeAttr('aria-expanded');
				$('a[href*=drug-detail-info]').removeAttr('aria-expanded');
				if('drug-detail-info' == $('#navigation-tabs .active').find('a').attr("href").substr(1)){
					$('#print-link').removeClass('hidden');
				}else if ('drug-detail-price' == $('#navigation-tabs .active').find('a').attr("href").substr(1)){
					$('#print-link').addClass('hidden');
				}

			});
		},
		/**
		 * show drug info and change clicked link color
		 * 
		 * @param index link index
		 */
		showDrugInfo: function(index) {
			$('[id^=drug-link-]').each(function() {
			    $(this).removeClass('clicked_link');
			    $(this).addClass('body-copy-link');
			});
			$('#drug-link-'+index).removeClass('body-copy-link');
			$('#drug-link-'+index).addClass('body-copy-medium clicked_link');
			
			$('[id^=details-info-]').each(function() {
			    $(this).addClass('hidden');
			});
			$('#details-info-'+index).removeClass('hidden');
			$('html, body').animate({
		        scrollTop: $('#drug-info-name-'+index).offset().top
		    }, 1000);
			
		},
		/**
		 * submit cancel form
		 * 
		 */
		submitCancelForm: function() {
			$("#PharmacyCancelDrugSelection" ).submit();
		},
		/**
		 * go back
		 * 
		 */
		goBack: function(){
			window.history.back();
		},
		/**
		 * select drug
		 * 
		 * @param drugDescription drug description
		 * @param ndc number
		 */
		selectDrug:function(drugDescription, ndcNumber){
			var newPrescriptionForm = document.forms['PharmacyAddDrugForm'];
			newPrescriptionForm.drugDescription.value = drugDescription;
			newPrescriptionForm.ndcNumber.value = ndcNumber;
			newPrescriptionForm.submit();
		}, 
		
		//Sets Drug detail aria expanded value to true when Drug detail displays only
		rxDrugDetailAriaExpandSwitch: function() {
			if($('a[target="drug-detail-info"]').parent().hasClass('active')) {
				$('a[target="drug-detail-price"]').attr('aria-selected', 'false');
				$('a[target="drug-detail-info"]').attr('aria-selected', 'true');
			} else {
				$('a[target="drug-detail-price"]').attr('aria-selected', 'true');
				$('a[target="drug-detail-info"]').attr('aria-selected', 'false');
			};
		},
	}
	
	if (typeof window.COSTCO === "undefined") {
	   window.COSTCO = new Object();
	} 
			
	window.COSTCO.rxDrugDetails = rxDrugDetails;
				
	return rxDrugDetails;
		    
});


// WEBPACK FOOTER //
// ./js/rx/rxdrugdetails.js